// src/utils/scheduleHours.js

// Command Team = 14h; everything else = 13h.
// If a slot has explicit start/end times, those override defaults.

export const COMMAND_TEAM_ROLES = new Set([
  "Incident Command",
  "Unified Command",
  "Planning",
  "Logistics",
  "Treatment",
]);

export const normalizeRoleLabel = (label = "") =>
  label.replace(/\s+#\d+$/, "");

/* -------------------- defaults -------------------- */

export function getDefaultSlotHours(roleLabel = "") {
  const base = normalizeRoleLabel(roleLabel);
  return COMMAND_TEAM_ROLES.has(base) ? 14 : 13;
}

export function getDefaultSlotTimes(roleLabel = "") {
  // Derived from your current hour rules
  const hrs = getDefaultSlotHours(roleLabel);
  return {
    start: "06:00",
    end: addHours("06:00", hrs),
  };
}

/* -------------------- helpers -------------------- */

function addHours(start, hrs) {
  const [h, m] = start.split(":").map(Number);
  const total = h * 60 + m + hrs * 60;
  const outH = Math.floor((total % 1440) / 60);
  const outM = total % 60;
  return `${String(outH).padStart(2, "0")}:${String(outM).padStart(2, "0")}`;
}

export function computeHoursFromTimes(start, end) {
  if (!start || !end) return 0;

  const [sh, sm] = start.split(":").map(Number);
  const [eh, em] = end.split(":").map(Number);

  if ([sh, sm, eh, em].some((n) => Number.isNaN(n))) return 0;

  const startMin = sh * 60 + sm;
  const endMin = eh * 60 + em;

  let diff = endMin - startMin;

  // Overnight shift
  if (diff < 0) diff += 24 * 60;

  return diff / 60;
}

/* -------------------- main API -------------------- */

// Backwards compatible:
// - old: getSlotHours(roleLabel)
// - new: getSlotHours(roleLabel, { start, end })
export function getSlotHours(roleLabel = "", times) {
  if (times?.start && times?.end) {
    const hrs = computeHoursFromTimes(times.start, times.end);
    if (hrs > 0) return hrs;
  }
  return getDefaultSlotHours(roleLabel);
}
